// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import PoolOrdersByPoolPkgCode from './poolOrdersByPoolPkgCode';
import React from 'react';

function PoolOrdersByPoolPkgCodePage () {

    return (
        <AuthenticatedPage className="atp-page atp-pool-pool-orders-by-pkg-code-page">
            <PoolOrdersByPoolPkgCode />
        </AuthenticatedPage>
    );

}
PoolOrdersByPoolPkgCodePage.displayNAme = 'PoolOrdersByPoolPkgCodePage';

export default PoolOrdersByPoolPkgCodePage;
